import { useCaptureEvent } from "@Light/app/analytics";
import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { EnrollBottomSheet } from "../common/EnrollBottomSheet";
import { EnrollHelpButton } from "../EnrollHelpButtonFooter";
import { type IneligibleReason, ineligibleCopy } from "./ZipUtilityIneligible";

export type ZipUtilityIneligibleBottomSheetProps = {
  open: boolean;
  postalCode: string;
  reason?: IneligibleReason;
  onClose: () => void;
  /** Defaults to closing the sheet, which returns to the zip input. */
  onRetry?: () => void;
};

export const ZipUtilityIneligibleBottomSheet = ({
  open,
  postalCode,
  reason = "area",
  onClose,
  onRetry = onClose,
}: ZipUtilityIneligibleBottomSheetProps) => {
  useCaptureEvent({
    event: "enroll_zip_ineligible_viewed",
    condition: open,
    properties: { variant: "sheet", postal_code: postalCode, reason },
  });

  const { title, subtitle } = ineligibleCopy(reason, postalCode);

  return (
    <EnrollBottomSheet
      open={open}
      onClose={onClose}
      title={
        <span data-testid="zip-utility-ineligible-sheet-heading">{title}</span>
      }
      subtitle={subtitle}
      data-testid="zip-utility-ineligible-sheet"
      footer={
        <ButtonFooter>
          <Button
            size="lg"
            className="w-full"
            onClick={onRetry}
            data-testid="zip-utility-ineligible-sheet-retry"
          >
            Use a different zip code
          </Button>
          <EnrollHelpButton
            onClick={onClose}
            eventVariant="zip_utility_ineligible_sheet"
          >
            Is this incorrect? Reach out to us
          </EnrollHelpButton>
        </ButtonFooter>
      }
    />
  );
};
